import { z } from "zod";

/**
 * Deployment Statistics Response Schema
 *
 * Returns statistics for a deployment including:
 * - Session-level message counts
 * - Spending per session
 * - Session metadata (created/updated timestamps)
 */
export const DeploymentStatisticsResponseSchema = z.array(
  z.object({
    id: z.string().uuid(),
    chatId: z.string().uuid().nullable(),
    messageCount: z.number().int().nonnegative(),
    subscriptions: z
      .array(
        z.object({
          status: z.literal("ACTIVE")
        })
      )
      .optional(),
    updatedAt: z.string().datetime(),
    createdAt: z.string().datetime(),
    spent: z.number().int().nonnegative().optional()
  })
);

export type DeploymentStatisticsResponse = z.infer<typeof DeploymentStatisticsResponseSchema>;

/**
 * Get Statistics Path Variables Schema
 */
export const GetStatisticsPathVarsSchema = z.object({
  id: z.string().uuid()
});

export type GetStatisticsPathVars = z.infer<typeof GetStatisticsPathVarsSchema>;
